import axios from '../../http'

class standActivity {
  //展位列表
  getStandActivityList(cateId) {
    let url = `/api/db/booth/list?cateId=${cateId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新增展位
  getStandActivityAdd(data) {
    let url = `/api/db/booth/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //获取一级分类
  getFristClassify() {
    let url = `/api/category/levelone`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //撤销展位/取消竞价
  removeStand(data) {
    let url = `/api/db/booth/cancel`
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //选择供应商竞选胜出商品
  standSelect(data) {
    let url = `/api/db/booth/select`
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //展位商品
  getStandGoods(id, currentPage, goodsName, supplierId) {
    let url = `/api/db/booth/goods?id=${id}&currentPage=${currentPage}&goodsName=${goodsName}&supplierId=${supplierId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //添加平台商品
  addStandGoods(data) {
    let url = `/api/db/booth/choose`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //添加平台商品
  getBaseInfo(id) {
    let url = `/api/db/booth/detail?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}


export default standActivity